import { useState } from 'react';
import { ListTodo, Rocket, GitBranch, Brain } from 'lucide-react';
import BacklogView from './BacklogView';
import FeaturesView from './FeaturesView';
import LineageView from './LineageView';
import FeatureDetailView from './FeatureDetailView';
import LearningView from './LearningView';

type View = 'backlog' | 'features' | 'lineage' | 'learning';

export default function Workshop() {
  const [view, setView] = useState<View>('backlog');
  const [openFeatureId, setOpenFeatureId] = useState<string | null>(null);

  // When a feature is opened, the detail view takes over the whole pane.
  if (openFeatureId) {
    return (
      <FeatureDetailView
        featureId={openFeatureId}
        onBack={() => setOpenFeatureId(null)}
      />
    );
  }

  return (
    <div className="flex flex-col h-full">
      {/* Sub-tab bar */}
      <div className="flex items-center gap-1 mb-3">
        <button
          onClick={() => setView('backlog')}
          className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            view === 'backlog'
              ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300'
              : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-surface-800'
          }`}
        >
          <ListTodo size={14} />
          Backlog
        </button>
        <button
          onClick={() => setView('features')}
          className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            view === 'features'
              ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300'
              : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-surface-800'
          }`}
        >
          <Rocket size={14} />
          Features
        </button>
        <button
          onClick={() => setView('lineage')}
          className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            view === 'lineage'
              ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300'
              : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-surface-800'
          }`}
        >
          <GitBranch size={14} />
          Lineage
        </button>
        <button
          onClick={() => setView('learning')}
          className={`flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            view === 'learning'
              ? 'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300'
              : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-surface-800'
          }`}
        >
          <Brain size={14} />
          Learning
        </button>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden">
        {view === 'backlog' && <BacklogView onOpenFeature={setOpenFeatureId} />}
        {view === 'features' && <FeaturesView onOpenFeature={setOpenFeatureId} />}
        {view === 'lineage' && <LineageView />}
        {view === 'learning' && <LearningView />}
      </div>
    </div>
  );
}
